import {APIClient} from '../backend/ApiClient';

export const useGiveConsent = () => {
    const apiClient = APIClient();

    const giveConsent = async (language: string,
                               disclaimerId: string,
                               fileId: string | null | undefined,
                               isConsentGiven: boolean) => {
        return apiClient.giveConsent(language, disclaimerId, fileId, isConsentGiven);
    };

    return {giveConsent: giveConsent};
};